import Comp from "./RoleManagement";

export default Comp;
